import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/check_gray_16.png'


const _withScopeId = n => (_pushScopeId("data-v-96b01322"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-matches" }
const _hoisted_2 = { class: "options" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-secondary btn-sm",
  for: "showSetsChk"
}, " Show matching ", -1))
const _hoisted_4 = { class: "matches" }
const _hoisted_5 = {
  key: 0,
  class: "instructions"
}
const _hoisted_6 = {
  key: 1,
  class: "instructions"
}
const _hoisted_7 = { class: "item-card" }
const _hoisted_8 = ["id", "value"]
const _hoisted_9 = ["for"]
const _hoisted_10 = {
  key: 0,
  class: "item-actions"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "other-sets"
}
const _hoisted_13 = { class: "instructions" }
const _hoisted_14 = {
  key: 0,
  class: "list-unstyled show-sets"
}
const _hoisted_15 = { class: "item-card" }
const _hoisted_16 = ["id", "value"]
const _hoisted_17 = ["for"]
const _hoisted_18 = { class: "item-actions" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-actions" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-inline btn-link",
    "data-bs-toggle": "modal",
    "data-bs-target": "#addSetModal"
  }, " Add a source ")
], -1))
const _hoisted_21 = {
  key: 1,
  class: "set-details"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Select a profile to add as matching source: ", -1))
const _hoisted_26 = {
  key: 0,
  class: "invalid-feedback"
}

import { computed, Ref, ref, watch } from 'vue'
import { DataGroup, DataGroupType } from '@/gp/GroupAdminModel'
import { useTokenManager } from '@/auth/TokenManager'
import { DateTimeUtil } from '@/util/LuxonUtil'
import { CompositeId } from '@/rd/CompositeId'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { ProfileUtils } from './ProfileUtils'
import { isDefined } from '@/util/TypeScriptUtil'
import { LoadMode } from '@/util/AsyncData'
import { uniq } from 'lodash'
import { PersonSet } from '@/rd/ResearchDataModel'
import ProfileCard from '@/manage/ProfileCard.vue'
import ResearchGroupItem from '@/manage/researchgroups/ResearchGroupItem.vue'
import SystemGroupItem from '@/manage/SystemGroupItem.vue'
import UserLink from '@/manage/users/UserLink.vue'
import Modal from '@/util/Modal.vue'
import ProfileSelector from './ProfileSelector.vue'
import PersonSetModal from '../PersonSetModal.vue'
import { setEqual } from '@/util/IterableUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileMatchesEditor',
  props: {
    personId: {}
  },
  setup(__props: any) {

const props = __props;



const showSetsRef = ref(false)
const showRelSetsRef = ref(false)
const selectedIdRef = ref<string>()
const addedMemberIdsRef = ref([]) as Ref<CompositeId[]>
const addSetMemberIdRef = ref<string>()
const addSetOwnerIdRef = ref<string>()
const personSetModalRef = ref<InstanceType<typeof PersonSetModal>>()

const viewPersonStore = useViewPersonStore()
const dataGroupStore = useDataGroupStore()
const tokenManager = useTokenManager()

const viewPersonRef = computed(() => viewPersonStore.getAsyncPerson(props.personId, LoadMode.EnsureLoaded)?.data)
const personSetsRef = computed(() => viewPersonStore.getAsyncPersonSets(viewPersonRef.value?.id, LoadMode.EnsureLoaded)?.data ?? [])
const dataGroupsRef = computed(() => {
  const personGroupIds = viewPersonRef.value?.groupIds ?? []
  const setOwnerGroupIds = personSetsRef.value.map(set => set.groupId)
  const allGroupIds = uniq([...personGroupIds, ...setOwnerGroupIds])
  // load them all at once
  return dataGroupStore.getAsyncGroupList(allGroupIds, LoadMode.EnsureLoaded)
    .map(a => a.data).filter(isDefined)
})
const dataGroupsMapRef = computed(() => new Map(dataGroupsRef.value.map(dg => [dg.id!, dg])))

const profileMatchIdsRef = computed(() => ProfileUtils.getNonPlaceholderIds(viewPersonRef.value?.matchIds ?? [], dataGroupsRef.value)
  .map(id => CompositeId.parse(id)))

const otherSetsRef = computed(() => personSetsRef.value
  .filter(set => !isSelfMatchSet(set) && getMatchCount(set) > 1)
  .sort(compareSet))

const hasOtherMatchesRef = computed(() => profileMatchIdsRef.value.some(id => !isThisProfile(id)))
const canShowSetsRef = computed(() => personSetsRef.value.length > 0)

const selectedSetRef = computed(() => {
  if (!selectedIdRef.value)
    return undefined

  return getSelfMatchSet(CompositeId.parse(selectedIdRef.value)) ?? 
    personSetsRef.value.find(set => set.id == selectedIdRef.value)
})

const selectedOwnerGroupRef = computed(() => {
  const selectedGroupId = CompositeId.getGroupId(selectedIdRef.value)
  return dataGroupsMapRef.value.get(selectedGroupId ?? '')
})

watch(() => props.personId, () => {
  // reset interactive state
  showSetsRef.value = false
  showRelSetsRef.value = false
  selectedIdRef.value = undefined
})

watch([profileMatchIdsRef, otherSetsRef], () => {
  if (!selectedIdRef.value) {
    // set a default selection (if possible)
    selectedIdRef.value = profileMatchIdsRef.value.find(id => getSelfMatchCount(id) > 1)?.value
      ?? otherSetsRef.value.at(0)?.id
  }
}, { immediate: true })

function compareSet(a: PersonSet, b: PersonSet) {
  const aGroup = dataGroupsMapRef.value.get(a.groupId!)
  const bGroup = dataGroupsMapRef.value.get(b.groupId!)
  if (!aGroup || !bGroup)
    return 0

  const isThisOwned = (dg: DataGroup) => CompositeId.hasGroupId(props.personId, dg.id!)
  const isSelfOwned = (dg: DataGroup) => dg.ownerId == tokenManager.current.userId
  const isSystemGroup = (dg: DataGroup) => dg.groupType == DataGroupType.System

  return +isThisOwned(bGroup) - +isThisOwned(aGroup) || // sets defined by this profile (first)
      +isSelfOwned(bGroup) - +isSelfOwned(aGroup) || // own groups (first)
      +isSystemGroup(aGroup) - +isSystemGroup(bGroup) || // system group (last)
      (a.id! == b.id! ? 0 : (a.id! < b.id! ? -1 : 1)) // others in arbitrary but stable order (by set ids)
}

function isSelfMatchSet(set: PersonSet) {
  // a "match owned" set is owned by a matching person AND includes the person as a member
  return profileMatchIdsRef.value.some(id => 
    CompositeId.hasGroupId(set.id, id.groupId) && set.memberIds.includes(id.value))
}

function getSelfMatchSet(personId: CompositeId) {
  // NOTE: a person id uniquely identifies a set for a set owner, because the same owner cannot include the
  // same person in more than one set
  return personSetsRef.value.find(set =>
    CompositeId.hasGroupId(set.id, personId.groupId) && set.memberIds.includes(personId.value))
}

function getSelfMatchCount(personId: CompositeId) {
  return getMatchCount(getSelfMatchSet(personId))
}

function getOwnerGroup(set: PersonSet) {
  return dataGroupsMapRef.value.get(set.groupId!)
}

function hasOwnerGroupType(set: PersonSet, type: DataGroupType) {
  return getOwnerGroup(set)?.groupType == type
}

function isSetOwner(groupId: string) {
  return personSetsRef.value.some(set => CompositeId.hasGroupId(set.id, groupId))
}

function canEditGroup(groupId: string) {
  return dataGroupsMapRef.value.get(groupId)?.ownerId == tokenManager.current.userId
}

function showEditAction(set: PersonSet | undefined) {
  return set && selectedSetRef.value == set && canEditGroup(set.groupId!)
}

function getMatchCount(set: PersonSet | undefined) {
  return set?.memberIds.filter(isProfileMatch).length ?? 0
}

function getMatchCountText(count: number) {
  return count > 1 ? `Defines ${count} matches` : 'Does not define any matches'
}

function isProfileMatch(memberId: string) {
  return profileMatchIdsRef.value.some(id => id.value == memberId)
}

function isSelectedSetMember(personId: CompositeId) {
  return selectedSetRef.value && selectedSetRef.value.memberIds.includes(personId.value) &&
    getMatchCount(selectedSetRef.value) > 1 // ignore singleton sets
}

function isThisProfile(personId: CompositeId) {
  return personId.value == props.personId
}

function showSelected(id: string) {
  return showSetsRef.value && selectedIdRef.value == id
}

function showSetModalForMatch(personId: CompositeId) {
  return showSetModal(getSelfMatchSet(personId), personId.value)
}

function showSetModal(set: PersonSet | undefined, ownerId?: string) {
  personSetModalRef.value?.open(set, ownerId)
}

function addSet() {
  showSetModal(undefined, addSetOwnerIdRef.value)
  addSetOwnerIdRef.value = undefined
}

const addSetOwnerErrorRef = computed(() => {
  if (addSetOwnerIdRef.value) {
    const ownerGroupId = CompositeId.getGroupId(addSetOwnerIdRef.value)
    const ownerGroup = dataGroupStore.getLoadedGroup(ownerGroupId ?? '')
    if (ownerGroup?.ownerId != tokenManager.current.userId)
      return 'Select a profile you manage.'
  }
  return undefined
})

function canAddSetOwner() {
  return addSetOwnerIdRef.value && !addSetOwnerErrorRef.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        id: "showSetsChk",
        class: "btn-check",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showSetsRef).value = $event))
      }, null, 512), [
        [_vModelCheckbox, showSetsRef.value]
      ]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      (hasOtherMatchesRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " These profiles are matches for this profile. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, " No matches are defined for this profile. ")),
      _createElementVNode("ul", {
        class: _normalizeClass(["list-unstyled matches-list", { ['show-sets']: showSetsRef.value }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileMatchIdsRef.value, (id) => {
          return (_openBlock(), _createElementBlock("li", {
            key: id.value,
            class: _normalizeClass({ current: showSetsRef.value && selectedIdRef.value == id.value })
          }, [
            (showSetsRef.value && isSelectedSetMember(id))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _imports_0,
                  class: _normalizeClass(["member-check", { self: selectedIdRef.value == id.value }])
                }, null, 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: id.value,
                class: "btn-check",
                name: "personSet",
                value: id.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedIdRef).value = $event))
              }, null, 8, _hoisted_8), [
                [_vModelRadio, selectedIdRef.value]
              ]),
              _createElementVNode("label", {
                for: id.value
              }, [
                _createVNode(ProfileCard, {
                  "person-id": id.value,
                  "show-profile-type": "",
                  "this-profile": isThisProfile(id),
                  static: showSetsRef.value || isThisProfile(id),
                  "show-hover": showSetsRef.value || !isThisProfile(id),
                  raised: showSelected(id.value)
                }, null, 8, ["person-id", "this-profile", "static", "show-hover", "raised"])
              ], 8, _hoisted_9),
              (showSetsRef.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createTextVNode(_toDisplayString(getMatchCountText(getSelfMatchCount(id))) + " ", 1),
                    (showEditAction(getSelfMatchSet(id)))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-inline btn-link",
                          onClick: ($event: any) => (showSetModalForMatch(id))
                        }, " Change ", 8, _hoisted_11))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2))
        }), 128))
      ], 2)
    ]),
    (showSetsRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (otherSetsRef.value.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" These sources also define matching for this profile. ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" No other sources define matching for this profile. ")
                ], 64))
          ]),
          (otherSetsRef.value.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherSetsRef.value, (set) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: set.id,
                    class: _normalizeClass({ current: selectedIdRef.value == set.id })
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: set.id,
                        class: "btn-check",
                        name: "personSet",
                        value: set.id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedIdRef).value = $event))
                      }, null, 8, _hoisted_16), [
                        [_vModelRadio, selectedIdRef.value]
                      ]),
                      _createElementVNode("label", {
                        for: set.id
                      }, [
                        (hasOwnerGroupType(set, _unref(DataGroupType).Profile))
                          ? (_openBlock(), _createBlock(ProfileCard, {
                              key: 0,
                              "person-id": getOwnerGroup(set)?.startItemId,
                              "show-profile-type": "",
                              static: "",
                              "show-hover": "",
                              raised: showSelected(set.id!)
                            }, null, 8, ["person-id", "raised"]))
                          : _createCommentVNode("", true),
                        (hasOwnerGroupType(set, _unref(DataGroupType).Research))
                          ? (_openBlock(), _createBlock(ResearchGroupItem, {
                              key: 1,
                              "data-group-id": set.groupId
                            }, null, 8, ["data-group-id"]))
                          : _createCommentVNode("", true),
                        (hasOwnerGroupType(set, _unref(DataGroupType).System))
                          ? (_openBlock(), _createBlock(SystemGroupItem, {
                              key: 2,
                              small: "",
                              "show-hover": "",
                              raised: showSelected(set.id!)
                            }, null, 8, ["raised"]))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_17),
                      _createElementVNode("div", _hoisted_18, [
                        _createTextVNode(_toDisplayString(getMatchCountText(getMatchCount(set))) + " ", 1),
                        (showEditAction(set))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-inline btn-link",
                              onClick: ($event: any) => (showSetModal(set))
                            }, " Change ", 8, _hoisted_19))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _hoisted_20
        ]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          (selectedSetRef.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                _createTextVNode(" Match set last modified " + _toDisplayString(_unref(DateTimeUtil).toUserActionDate(selectedSetRef.value?.modifiedDate)) + " by ", 1),
                _createVNode(UserLink, {
                  "user-id": selectedSetRef.value?.modifiedUserId,
                  dimmed: ""
                }, null, 8, ["user-id"])
              ]))
            : (selectedIdRef.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, " This profile does not define a match set "))
              : (_openBlock(), _createElementBlock("span", _hoisted_24, " No match set selected "))
        ]))
      : _createCommentVNode("", true),
    _createVNode(PersonSetModal, {
      ref_key: "personSetModalRef",
      ref: personSetModalRef,
      "person-id": _ctx.personId
    }, null, 8, ["person-id"]),
    _createVNode(Modal, {
      id: "addSetModal",
      "ok-close": "",
      "ok-disabled": !canAddSetOwner(),
      onShown: _cache[4] || (_cache[4] = ($event: any) => (addSetOwnerIdRef.value = undefined)),
      onOk: addSet
    }, {
      title: _withCtx(() => [
        _createTextVNode("Add a source")
      ]),
      okText: _withCtx(() => [
        _createTextVNode("Add source")
      ]),
      default: _withCtx(() => [
        _hoisted_25,
        _createElementVNode("div", null, [
          _createVNode(ProfileSelector, {
            modelValue: addSetOwnerIdRef.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((addSetOwnerIdRef).value = $event))
          }, null, 8, ["modelValue"]),
          (!canAddSetOwner())
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(addSetOwnerErrorRef.value), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["ok-disabled"])
  ]))
}
}

})